import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, useModal } from "../../modal";
import { Button, TableContainer, Paper } from "@mui/material";
import {
  GridContainer,
  GridItem,
  DataCard,
  DataCardHeader,
  DataCardTitle,
} from "./PeriodicIso.styles";
import PeriodicIsoBaseData from "./PeriodicIso.baseData";
import { AccountBalance } from "@mui/icons-material";
import HoldingsTable from "./PeriodicIso.holdings";
import { ResetStore } from "./PeriodicIso.slice";

const PeriodicIsoResultModal = () => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const { isOpen } = useSelector((state) => state.modal);
  const { isoID, isoName, consolidatedData, merchantData } = useSelector(
    (state) => state.periodicIso
  );
  // Solo renderizar el modal si está abierto
  if (!isOpen) {
    return null;
  }

  const handleClose = () => {
    close();
    dispatch(ResetStore());
  };

  const downloadCSV = () => {
    const headers = [
      "Date",
      "Holding Name",
      "Holding ID",
      "Holding Settlement",
      "Holding Amount",
      "Holding Trans. Count",
      "Holding MDR Fee",
      "Holding Proc. Fee",
      "Brand Name",
      "Brand ID",
      "Brand Settlement",
      "Brand Amount",
      "Brand Trans. Count",
      "Brand MDR Fee",
      "Brand Proc. Fee",
      "MID",
      "Merchant Name",
      "Merchant Store",
      "Merchant Settlement",
      "Merchant Amount",
      "Merchant Trans. Count",
      "Merchant MDR Fee",
      "Merchant Proc. Fee",
      "Terminal ID",
      "Terminal Exchange Name",
      "Terminal Settlement",
      "Terminal Amount",
      "Terminal Trans. Count",
      "Terminal MDR Fee",
      "Terminal Proc. Fee",
    ];

    const formatDecimal = (value) => {
      if (typeof value === "string") {
        const cleanedValue = value.replace(",", ".").replace(/[^0-9.]/g, "");

        if ((cleanedValue.match(/\./g) || []).length > 1) {
          return "0.0000";
        }

        const number = parseFloat(cleanedValue);

        if (!isNaN(number)) {
          return number.toFixed(4);
        }
      }

      if (typeof value === "number") {
        return value.toFixed(4);
      }

      return "0.0000";
    };

    const formatDate = (rawDate) => {
      const year = rawDate.toString().slice(0, 4);
      const month = rawDate.toString().slice(4, 6);
      const day = rawDate.toString().slice(6, 8);
      return `${month}/${day}/${year}`;
    };

    const rows = [];

    merchantData.forEach((entry) => {
      const date = formatDate(entry.date);
      const holdings = entry.holdings;

      const holdingAmountDue = formatDecimal(holdings.amountDue);
      const holdingTxAmount = formatDecimal(holdings.transactionsAmount);
      const holdingTxCount = holdings.transactionsCount;
      const holdingTxMDR = formatDecimal(holdings.txMDR);
      const holdingTxProcessing = formatDecimal(holdings.txProcessing);

      if (holdings.groups && holdings.groups.group) {
        holdings.groups.group.forEach((group) => {
          if (group.merchants && group.merchants.merchant) {
            group.merchants.merchant.forEach((merchant) => {
              if (merchant.terminals && merchant.terminals.terminal) {
                merchant.terminals.terminal.forEach((terminal) => {
                  const row = [
                    date,
                    holdings.merchantHolding || "",
                    holdings.merchantHoldingID || "",
                    holdingAmountDue,
                    holdingTxAmount,
                    holdingTxCount,
                    holdingTxMDR,
                    holdingTxProcessing,
                    group.merchantGroup || "",
                    group.merchantGroupID || "",
                    formatDecimal(group.amountDue),
                    formatDecimal(group.transactionsAmount),
                    group.transactionsCount,
                    formatDecimal(group.txMDR),
                    formatDecimal(group.txProcessing),
                    merchant.name || "",
                    merchant.ID || "",
                    merchant.store || "",
                    formatDecimal(merchant.amountDue),
                    formatDecimal(merchant.transactionsAmount),
                    merchant.transactionsCount,
                    formatDecimal(merchant.txMDR),
                    formatDecimal(merchant.txProcessing),
                    terminal.terminalID || "",
                    terminal.exchangeName || "N/A",
                    formatDecimal(terminal.amountDue),
                    formatDecimal(terminal.transactionsAmount),
                    terminal.transactionsCount,
                    formatDecimal(terminal.txMDR),
                    formatDecimal(terminal.txProcessing),
                  ];
                  rows.push(row);
                });
              } else {
                const row = [
                  date,
                  holdings.merchantHolding || "",
                  holdings.merchantHoldingID || "",
                  holdingAmountDue,
                  holdingTxAmount,
                  holdingTxCount,
                  holdingTxMDR,
                  holdingTxProcessing,
                  group.merchantGroup || "",
                  group.merchantGroupID || "",
                  formatDecimal(group.amountDue),
                  formatDecimal(group.transactionsAmount),
                  group.transactionsCount,
                  formatDecimal(group.txMDR),
                  formatDecimal(group.txProcessing),
                  merchant.name || "",
                  merchant.ID || "",
                  merchant.store || "",
                  formatDecimal(merchant.amountDue),
                  formatDecimal(merchant.transactionsAmount),
                  merchant.transactionsCount,
                  formatDecimal(merchant.txMDR),
                  formatDecimal(merchant.txProcessing),
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                  "",
                ];
                rows.push(row);
              }
            });
          } else {
            const row = [
              date,
              holdings.merchantHolding || "",
              holdings.merchantHoldingID || "",
              holdingAmountDue,
              holdingTxAmount,
              holdingTxCount,
              holdingTxMDR,
              holdingTxProcessing,
              group.merchantGroup || "",
              group.merchantGroupID || "",
              formatDecimal(group.amountDue),
              formatDecimal(group.transactionsAmount),
              group.transactionsCount,
              formatDecimal(group.txMDR),
              formatDecimal(group.txProcessing),
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
              "",
            ];
            rows.push(row);
          }
        });
      } else {
        const row = [
          date,
          holdings.merchantHolding || "",
          holdings.merchantHoldingID || "",
          holdingAmountDue,
          holdingTxAmount,
          holdingTxCount,
          holdingTxMDR,
          holdingTxProcessing,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ];
        rows.push(row);
      }
    });

    const csvContent = [headers, ...rows]
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "date_range_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal
      fullScreen
      actions={
        <>
          <Button onClick={handleClose} variant="outlined">
            Close
          </Button>
          <Button onClick={downloadCSV} variant="contained">
            Download CSV
          </Button>
        </>
      }
    >
      <GridContainer>
        <GridItem xs={12}>
          <PeriodicIsoBaseData
            isoID={isoID}
            isoName={isoName}
            consolidatedData={consolidatedData}
          />
        </GridItem>
        <GridItem xs={12}>
          <GridContainer spacing={2}>
            <GridItem xs={12}>
              <DataCard>
                <DataCardHeader>
                  <AccountBalance color="primary" />
                  <DataCardTitle>Holding company</DataCardTitle>
                </DataCardHeader>
                <TableContainer component={Paper}>
                  <HoldingsTable holdingList={merchantData} />
                </TableContainer>
              </DataCard>
            </GridItem>
          </GridContainer>
        </GridItem>
      </GridContainer>
    </Modal>
  );
};

export default PeriodicIsoResultModal;
